"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateReferralCodeSyntax = validateReferralCodeSyntax;
const errors_1 = require("../errors");
const loglevel_1 = require("loglevel");
function validateReferralCodeSyntax(code) {
    if (code === null || code === undefined) {
        loglevel_1.default.error(`Referral code cannot be null or undefined: `, code);
        throw new errors_1.InvalidReferralCodeError(code);
    }
    if (code.trim() === '') {
        loglevel_1.default.error(`Referral code cannot be empty: `, code);
        throw new errors_1.InvalidReferralCodeError(code);
    }
    if (code.length !== 8) {
        loglevel_1.default.error(`Invalid referral code format: `, code);
        throw new errors_1.InvalidReferralCodeError(code);
    }
    if (!/^[A-Z0-9]{8}$/.test(code)) {
        loglevel_1.default.error(`Referral code must contain only uppercase letters and numbers: `, code);
        throw new errors_1.InvalidReferralCodeError(code);
    }
}
